import c from '../common';

export default{
    "intro": c.intro.chn,
    "shopAddress" : "分店地址",
    
    "OpeningHour":"營業時間",


};